import { Link, useLocation } from "@tanstack/react-router"
import { cn } from "@/lib/utils"

const sections = [
  { to: "/admin/waitlist", label: "Invite Users", match: "/admin/waitlist" },
]

export function AdminNav() {
  const location = useLocation()

  return (
    <div className="mb-6 flex gap-1 border-b pb-0">
      {sections.map(({ to, label, match }) => {
        const active = location.pathname.startsWith(match)
        return (
          <Link
            key={to}
            to={to}
            className={cn(
              "-mb-px border-b-2 px-4 py-2 text-sm font-medium transition-colors",
              active
                ? "border-foreground text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground"
            )}
          >
            {label}
          </Link>
        )
      })}
    </div>
  )
}
